import React, { useState } from 'react';
import { get } from 'lodash';
import moment from 'moment';
import { Table, Card } from 'react-bootstrap';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';

import styled from 'styled-components';
import Pagination from '../../../app/components/forumPagination/pagination';
import { CustomDropdownStyle } from '../../../app/components/styledComponents/StyledCustomDropdown';
import DropDownIcon from '../../../app/components/svgIcons/DropDownIcon';


const rowsPerPage = [5, 10, 20, 30, 50];

const OrderTableView = ({
  tableData,
  columns,
  handlePerPageChange = () => {},
  handlePageChange = () => {},
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(5);

  const createKey = (item, column) => {
    return item.id + (column.path || column.key);
  };

  const formatDate = (date) => moment(new Date(date)).format('Do MMM YYYY');

  const renderCell = (item, column) => {
    if (column.content) return column.content(item);
    if (column.path === 'createdAt' || column.path === 'updatedAt') {
      return formatDate(get(item, column.path));
    }
    return get(item, column.path) ?? '-';
  };

  return (
    <ItemsTable className="activity-table">
      <Table responsive="sm">
        <thead>
          <tr>
            {columns.map((column) => (
              <th>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData?.content?.map((item, index) => (
            <tr key={item.id || index}>
              {columns.map((column) => (
                <>
                  <td
                    key={createKey(item, column)}
                    className={column?.alignBody}
                  >
                    {renderCell(item, column)}
                  </td>
                </>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
      <FooterPagination className="p-0">
        <RowSelect>
          <PageResult>Row Per Page</PageResult>
          <CustomDropdownStyle
            toggleClassName={'table-dropdown ms-0 table-text'}
            className="custom-drop-down table-dropdown-custom topic-dropdown bg-white mx-3"
            dropdownToggle={
              <span className="flex-center p-2 w-100 justify-content-between">
                <h6 className="me-1 me-lg-2 mb-0 ">{rowPerPage || 2}</h6>
                <DropDownIcon rotate="down" size={'15px'} />
              </span>
            }
            dropdownMenu={
              <>
                {rowsPerPage.map((number, index) => {
                  return (
                    <DropdownItem
                      key={index}
                      onClick={() => {
                        handlePerPageChange(number);
                        setRowPerPage(number);
                        setCurrentPage(1);
                      }}
                    >
                      {number}
                    </DropdownItem>
                  );
                })}
              </>
            }
          />
          <PageResult className="page-result">
            Result:{rowPerPage * currentPage - (rowPerPage - 1)} -{' '}
            {+currentPage * +rowPerPage <= tableData?.totalElements
              ? +currentPage * +rowPerPage
              : tableData?.totalElements}{' '}
            of {tableData?.totalElements || 0}
          </PageResult>
        </RowSelect>
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={tableData.totalElements || 0}
          pageSize={rowPerPage || 5}
          onPageChange={(page) => {
            handlePageChange(page - 1);
            setCurrentPage(page);
          }}
        />
      </FooterPagination>
    </ItemsTable>
  );
};

const ItemsTable = styled(Card)`
  border: 0;
  overflow: auto;

  table {
    thead {
      tr {
        th {
          padding: 15px;
          border-bottom: 1px solid ${({ theme }) => theme.lightGray1};
          font-size: 16px;
          font-weight: 500;
          color: ${({ theme }) => theme.secondaryLight};
          vertical-align: middle;
          white-space: nowrap;
          &:first-child {
            padding: 15px 30px;
          }
        }
      }
    }
    tbody {
      tr {
        &:nth-child(even) {
          td {
            background-color: ${({ theme }) => theme.lightGray2};
          }
        }
        td {
          padding: 15px;
          font-size: 14px;
          font-weight: 500;
          border: 0;
          text-align: left;
          white-space: nowrap;
          color: ${({ theme }) => theme.secondaryLight};
          vertical-align: middle;
          > svg {
            margin-right: 20px;
            color: ${({ theme }) => theme.mainPrimary};
          }
          .badge {
            font-size: 14px;
            font-weight: normal;
            border-radius: 30px;
            padding: 10px 15px;
            &.badge-active {
              color: ${({ theme }) => theme.success};
              background-color: ${({ theme }) => theme.success3};
            }
            &.badge-inactive {
              color: ${({ theme }) => theme.danger2};
              background-color: ${({ theme }) => theme.danger3};
            }
          }
          &:first-child {
            padding: 15px 30px;
          }
        }
      }
    }
  }
`;

const FooterPagination = styled.div`
  padding: 0 32px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 10px;
`;

const RowSelect = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  white-space: nowrap;
  max-width: 360px;
  width: 100%;
`;

const PageResult = styled.span`
  color: ${({ theme }) => theme.menuText};
  font-weight: 400;
`;

export default OrderTableView;
